import { z } from "zod"

export const operationalAlertCodeV1Schema = z.enum([
  "tenant_routing_unavailable",
  "command_failures",
  "outbox_lag",
  "authorization_anomalies",
])

export const frappeOperationalHealthV1Schema = z
  .object({
    healthVersion: z.literal(1),
    ok: z.boolean(),
    app: z.literal("impetusos"),
    appVersion: z.string().regex(/^\d+\.\d+\.\d+$/),
    schemaVersion: z.string().regex(/^\d{4}$/),
    observedAt: z.iso.datetime({ offset: true }),
    signals: z
      .object({
        commandFailures: z.number().int().nonnegative(),
        outboxOldestPendingSeconds: z.number().int().nonnegative(),
        outboxExceptions: z.number().int().nonnegative(),
        authorizationAnomalies: z.number().int().nonnegative(),
      })
      .strict(),
    alerts: z.array(operationalAlertCodeV1Schema).max(4),
  })
  .strict()

export type OperationalAlertCodeV1 = z.infer<typeof operationalAlertCodeV1Schema>
export type FrappeOperationalHealthV1 = z.infer<typeof frappeOperationalHealthV1Schema>
